const BackButtonTapped = {
  object_name: 'directDepositSubmittableBack',
  screen: 'directDepositSubmittableEmployerInfo',
  screen_name: 'directDepositSubmittableEmployerInfo',
  destination: 'DirectDepositSearch',
  cta_title: '',
}
const EditScreenViewed = {
  event: 'screen_viewed',
  object_name: 'directDepositSubmittableEmployerInfoReview',
  screen: 'directDepositSubmittableEmployerInfoReview',
  screenName: 'directDepositSubmittableEmployerInfoReview',
}

const FormScreenViewed = {
  event: 'screen_viewed',
  object_name: 'directDepositSubmittableEmployerInfo',
  screen: 'directDepositSubmittableEmployerInfo',
  screenName: 'directDepositSubmittableEmployerInfo',
}

const SuccessModalViewed = {
  object_name: 'directDepositSubmittableSuccess',
  screen: 'directDepositSubmittableEmployerInfoReview',
  screen_name: 'directDepositSubmittableEmployerInfoReview',
}

const NextButtonTapped = (employerName: string) => ({
  object_name: 'directDepositSubmittableEmployerInfoSubmit',
  screen: 'directDepositSubmittableEmployerInfo',
  screen_name: 'directDepositSubmittableEmployerInfo',
  cta_title: 'Next',
  employer_name: employerName,
})

const CancelButtonTapped = (employerName: string) => ({
  object_name: 'directDepositSubmittableEmployerInfoCancel',
  screen: 'directDepositSubmittableEmployerInfo',
  screen_name: 'directDepositSubmittableEmployerInfo',
  destination: 'DirectDepositSearch',
  cta_title: 'Cancel',
  employer_name: employerName,
})

const SubmitButtonTapped = (employerName: string) => ({
  object_name: 'directDepositSubmittableEmployerInfoReviewSubmit',
  screen: 'directDepositSubmittableEmployerInfoReview',
  screen_name: 'directDepositSubmittableEmployerInfoReview',
  cta_title: 'Submit',
  employer_name: employerName,
})

const EditButtonTapped = (employerName: string) => ({
  object_name: 'directDepositSubmittableEmployerInfoReviewEdit',
  screen: 'directDepositSubmittableEmployerInfoReview',
  screen_name: 'directDepositSubmittableEmployerInfoReview',
  destination: 'directDepositSubmittableEmployerInfo',
  cta_title: 'Edit',
  employer_name: employerName,
})

export {
  BackButtonTapped,
  EditScreenViewed,
  FormScreenViewed,
  SuccessModalViewed,
  NextButtonTapped,
  CancelButtonTapped,
  SubmitButtonTapped,
  EditButtonTapped,
}
